export const atsOptimizedTemplate = {
  id: 'ats-optimized',
  name: 'ATS-Optimized Standard',
  description: 'A clean, professional template designed for maximum ATS compatibility',
  sections: [
    {
      id: 'contact', type: 'contact', title: 'Contact Information', content: [],
      sectionData: {
        name: 'John Doe', email: 'john.doe@example.com',
        phone: '(555) 123-4567', location: 'San Francisco, CA',
        links: [
          { label: 'LinkedIn', url: 'https://linkedin.com/in/johndoe' },
          { label: 'GitHub', url: 'https://github.com/johndoe' },
        ],
      },
      visible: true, order: 1,
      styles: { fontSize: '16px', marginBottom: '1.5rem', textAlign: 'left' },
    },
    {
      id: 'summary', type: 'summary', title: 'Professional Summary',
      content: [{ type: 'paragraph', children: [{ text: 'Results-driven software engineer with 5+ years of experience.' }] }],
      visible: true, order: 2,
      styles: { fontSize: '14px', marginBottom: '1.5rem', textAlign: 'left' },
    },
    {
      id: 'experience', type: 'experience', title: 'Work Experience', content: [],
      sectionData: [{
        company: 'Tech Solutions Inc.', position: 'Senior Software Engineer',
        startDate: '2020-01', endDate: '2023-12', location: 'San Francisco, CA',
        highlights: [{ type: 'paragraph', children: [{ text: 'Led development of microservices architecture' }] }],
        achievements: [],
      }],
      visible: true, order: 3,
      styles: { fontSize: '14px', marginBottom: '1.5rem', textAlign: 'left' },
    },
    {
      id: 'education', type: 'education', title: 'Education', content: [],
      sectionData: [{
        institution: 'University of California, Berkeley',
        degree: 'Bachelor of Science', field: 'Computer Science',
        startDate: '2015-09', endDate: '2019-05', location: 'Berkeley, CA', gpa: '3.8',
        highlights: [{ type: 'paragraph', children: [{ text: 'Graduated with Honors' }] }],
      }],
      visible: true, order: 4,
      styles: { fontSize: '14px', marginBottom: '1.5rem', textAlign: 'left' },
    },
    {
      id: 'skills', type: 'skills', title: 'Skills',
      content: [{ type: 'paragraph', children: [{ text: 'JavaScript, TypeScript, Python\nReact, Node.js, Express\nGit, Docker, AWS' }] }],
      visible: true, order: 5,
      styles: { fontSize: '14px', marginBottom: '1.5rem', textAlign: 'left' },
    },
  ],
  styles: {
    fontFamily: 'Arial, sans-serif', fontSize: '14px', lineHeight: '1.6',
    margins: { top: '0.75in', bottom: '0.75in', left: '0.75in', right: '0.75in' },
  },
  metadata: { isATSOptimized: true, recommendedFor: ['software engineer'] },
}
